import { Button } from "../../../../../components/buttons/button";
import { ContainerCard } from "../../../../../components/cards/containerCard";
import { InformationCard } from "../../../../../components/cards/infoCard";
import { Icon } from "../../../../../components/icons/icon";
import { ChangePasswordModal } from "../../../../../components/modals/app_modals/changePasswordModal";
import { TitleSub } from "../../../../../components/typography/titleSub";
import { useModalControl } from "../../../../../customHooks/useModalControl";

export const CooperativeSecurity = () => {
  const { handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl();

  return (
    <div className="flex flex-row flex-wrap width-lim:flex-nowrap w-full gap-2 md:gap-6">
      <ContainerCard className="w-full width-lim:max-w-[653px] width-lim:min-h-[635px] order-last width-lim:order-first">
        <TitleSub
          title="Security"
          subtitle={`ThriftCorp maintains high standards for account security. That's why we've provided a couple of ways for you to protect your account.`}
        />

        <div className="mt-10">
          <div className="!py-6 border-t flex flex-row flex-wrap gap-4 items-center">
            <div className="flex items-center flex-1 min-w-full md:min-w-fit gap-4">
              <div className="p-[8px] md:p-[14px] rounded-lg bg-light-green-bg w-fit h-fit">
                <Icon
                  svg="password-key"
                  className="text-pry-green-200 w-[24px] h-[24px] md:w-[40px] md:h-[40px]"
                />
              </div>

              <div className="">
                <p className="text-sm font-medium max-w-[249px]">Password</p>
                <p className="text-xs opacity-60 max-w-[249px]">
                  Keep your password safe. We recommend you change your password
                  periodically.
                </p>
              </div>
            </div>

            <Button
              text="Change Password"
              onClick={() => {
                handleModalOpen("changePasswordModal");
              }}
              type="button"
              className="!min-w-[80px] ml-auto !max-w-fit"
              size="small"
              loading={false}
              disabled={false}
              icon={undefined}
              variation="primary"
            />
          </div>
        </div>
      </ContainerCard>

      <InformationCard
        info={`Manage your account security`}
        className="width-lim:!max-w-[345px] h-fit width-lim:sticky-top"
      />

      <ChangePasswordModal
        isModalOpen={modal === "changePasswordModal" && modalOpen}
        onModalClose={() => {
          handleModalClose();
        }}
        successCallback={() => {}}
      />
    </div>
  );
};
